import React from 'react';
import { Stack, Box, Typography, Chip } from '@mui/material';
import { Button } from '../MUIs';
import Canvas from '../Canvas/Canvas';
import BottomSheet from './BottomSheet';
import Commons from '../../Services/Common/Common';
import { useSelector } from 'react-redux';

const SignatureBottomSheet = ({
  signatureCanvas,
  signInputs,
  setSignInputs,
  alarmData,
  signUpload,
  onSave,
  onDismiss,
  confirmDisabled = false,
}) => {
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const [disabled, setDisabled] = React.useState(false);

  React.useEffect(() => {
    setDisabled(
      alarmData.find((f) => f.id === Commons.DecryptoAES(userInfo.userid))
        ?.checkYn === 'Y' || alarmData.find((f) => f.state === '3')
    );
  }, [alarmData]);

  return (
    <BottomSheet
      onDismiss={onDismiss}
      isHeaderChildren={true}
      headerText="서명등록"
      headerTextSx={{ fontWeight: 'bold' }}
      headerChildren={
        alarmData[0]?.state !== '3' && (
          <Chip
            sx={{ borderRadius: '8px', ml: 'auto' }}
            label="재설정"
            size="small"
            variant="outlined"
            onClick={() => {
              signatureCanvas.current.clear();
              signUpload && signUpload.clearFiles();
              setSignInputs({
                mapUrl: '',
                mapFiles: {},
              });
              setDisabled(false);
            }}
          />
        )
      }
      children={
        <Stack gap={2}>
          <Box
            sx={{
              p: 1,
              px: 0,
            }}
          >
            <Canvas
              signatureCanvas={signatureCanvas}
              userId={userInfo?.userNm}
              imageUrl={signInputs.mapUrl}
              disabled={disabled}
              onEnd={(e) => {
                if (signatureCanvas.current) {
                  signUpload && signUpload.clearFiles();
                  const signatureDataUrl = signatureCanvas.current.toDataURL();
                  const dataURL =
                    signatureCanvas.current.toDataURL('image/png');
                  const decodedData = atob(dataURL.split(',')[1]);
                  const byteNumbers = new Array(decodedData.length);

                  for (let i = 0; i < decodedData.length; i++) {
                    byteNumbers[i] = decodedData.charCodeAt(i);
                  }

                  const byteArray = new Uint8Array(byteNumbers);
                  const blob = new Blob([byteArray], {
                    type: 'image/png',
                  });
                  const file = new File(
                    [blob],
                    `${new Date()
                      .toISOString()
                      .replace(/T/, '')
                      .replace(/\..+/, '')
                      .replace(/-/g, '')
                      .replace(/:/g, '')}.png`,
                    {
                      type: 'image/png',
                    }
                  );

                  setSignInputs({
                    mapUrl: signatureDataUrl,
                    mapFiles: file,
                  });
                  signUpload &&
                    signUpload.FileChange({
                      target: { files: [file] },
                    });
                }
              }}
            />
          </Box>
          <Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
            [필수] 서명 정보 수집 및 이용에 동의합니다.
          </Typography>
          <Button
            sx={{
              mb: 2,
              width: '100%',
              height: '36px',
              borderRadius: '18px',
              backgroundColor: '#2DB400',
              '&:hover': {
                backgroundColor: '#26a300',
              },
            }}
            name="확인"
            onClick={onSave}
            disabled={disabled || confirmDisabled}
          />
        </Stack>
      }
    />
  );
};

export default SignatureBottomSheet;
